import React from "react";
export default ({ className, onClick, disabled = false, color = null, muted }) =>
  muted ? (
    <svg
      style={{ minWidth: 24 }}
      width="24"
      height="24"
      viewBox="-3 -5 24 24"
      fill="none"
      onClick={disabled ? null : onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={`${className || ""} ${disabled ? "disabled" : ""}`}
    >
      <path
        d="M1 3.9999C0.447715 3.9999 0 4.44762 0 4.9999V8.9999C0 9.55218 0.447715 9.9999 1 9.9999H3.58579C3.851 9.9999 4.10536 10.1053 4.29289 10.2928L7.29289 13.2928C7.92286 13.9228 9 13.4766 9 12.5857V1.41411C9 0.523209 7.92286 0.0770426 7.29289 0.707007L4.29289 3.70701C4.10536 3.89454 3.851 3.9999 3.58579 3.9999H1Z"
        fill="white"
      />
    </svg>
  ) : (
    <svg
      style={{ minWidth: 24 }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={`${className || ""} ${disabled ? "disabled" : ""}`}
      onClick={disabled ? null : onClick}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 4.48244C14 3.84085 14.5984 3.36383 15.1982 3.59171C18.5913 4.88095 21 8.15856 21 12.0001C21 15.8416 18.5913 19.1192 15.1982 20.4085C14.5984 20.6363 14 20.1593 14 19.5177V19.4558C14 19.0134 14.2941 18.6303 14.7021 18.4593C17.2254 17.4022 19 14.9072 19 12.0001C19 9.09296 17.2254 6.59794 14.7021 5.54083C14.2941 5.36987 14 4.98676 14 4.54432V4.48244ZM4 9.00008C3.44772 9.00008 3 9.4478 3 10.0001V14.0001C3 14.5524 3.44772 15.0001 4 15.0001H6.58579C6.851 15.0001 7.10536 15.1054 7.29289 15.293L10.2929 18.293C10.9229 18.9229 12 18.4768 12 17.5859V6.4143C12 5.52339 10.9229 5.07723 10.2929 5.70719L7.29289 8.70719C7.10536 8.89473 6.851 9.00008 6.58579 9.00008H4ZM16.5 12.0001C16.5 10.52 15.7868 9.21473 14.6878 8.39416C14.3899 8.17179 14 8.40741 14 8.7791V15.2159C14 15.5865 14.3878 15.8223 14.6856 15.6018C15.7858 14.7872 16.5 13.4811 16.5 12.0001Z"
        fill={color ? color : disabled ? "#4D4D4D" : "#fff"}
      />
    </svg>
  );
